import React, { useMemo } from 'react';

import { get } from 'lodash';

import { Column } from '../../../modules/table';
import { TransactionHistorySearch } from '../../../services/api/dto/Transactions';
import { TRANSACTION_TYPE } from '../../../types';

import './row-component.scss';

const styleMap: Record<string, any> = {
  operation: 'operation',
  details: 'details',
  payment: 'payment',
  date: 'date',
  status: 'status',
  action: 'action',
  sale: 'sale',
};

interface SpecialFields {
  tokenId: string;
}

interface IProps {
  rowData: TransactionHistorySearch;
  columns: Column<TransactionHistorySearch>[];
  onRowClick: (params: {
    id: number;
    type: TRANSACTION_TYPE;
    isHybrid?: boolean;
    specialFields: SpecialFields;
  }) => void;
}

const RowComponent: React.FC<IProps> = ({ rowData, columns, onRowClick }) => {
  const id = useMemo(() => {
    return get(rowData, 'originalOperationId', rowData.id);
  }, [rowData]);

  return (
    <div
      className="history-item"
      onClick={() =>
        onRowClick({
          id: id,
          type: rowData.type || 'EXCHANGE',
          specialFields: rowData.specialFields,
          isHybrid: !!get(rowData, 'specialFields.hybridIssue', false),
        })
      }
    >
      {columns.map((column) => {
        const columnData = column.dataGetter(rowData) || '';
        return (
          <div
            className={`history-item__${styleMap[column.name]}`}
            style={{ ...column.headerStyle }}
          >
            {column.Component ? (
              <column.Component data={columnData} status={rowData.status} />
            ) : (
              columnData
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RowComponent;
